import  '../styles/radiobox.css';

export default function RadioBox ( props ) {
	const optionKeys = Object.keys(props.options);

	

	let name = typeof props.name !== 'undefined' ? props.name : false;
	let model = props.model;

	if ( !name ){
		name = Object.keys(props.model)[0];
		model = props.model[name];

	}

	model = ( model === "true" || model === "false") ?
	  JSON.parse(model)
      : model;


	return <div className="radio-box">
		{ 
		  (props.children !== undefined) ? 
			<label className="radio-main-label">{props.children}</label> 
			:  ''
		}
		<div className="radio-options-container">
		{
			optionKeys.map(
				(optionKey ,i)=>(
					<div className="custom-radiobox">
						<label className="radio-container" htmlFor={name +i}>
							<input type="radio" 
								name={name} 
								id={name+i} 
								value={props.options[optionKey]}
								checked={ props.options[optionKey] === model }
								readOnly={true}
								onClick={(e) => ( props.handler(e.target.value , name) )}
								/>
							<span className="checkmark"></span>
							<span className="label">{optionKey}</span> 
						</label>

					</div>
				)
			)
		}
		</div>
	</div>

}